<app-page-header></app-page-header>
<app-style-view [mainColor]="'#00733f'"></app-style-view>
<div class="container py-2 book-container">
  <div class="row">
    <div class="col-md-3">
      <div class="card border-radius-0 bg-color-light border-0 box-shadow-2" (click)="toggleFilter()">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div>
                <h3 class="card-title mb-1 text-4 font-weight-bold">{{ 'SEARCH_LBL_FILTER' | translate }}</h3>
                <div>
                  <small class="text-muted">{{ 'SEARCH_LBL_DESCRIPTION' | translate }}</small>
                  <a class="collapse-icon pointer" (click)="toggleFilter()">
                    <i class="fas" [ngClass]="!showFilters ? 'fa-caret-square-left' : 'fa-caret-square-down'"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />

      @if (showFilters) {
        <div>
          @for (groupItem of filterGroups$ | async; track groupItem) {
            <div
              class="box-view-container">
              <div class="card bg-color-light border-radius-0 box-shadow-2">
                <div class="card-body">
                  <h5 class="card-title from-journal">{{ getTranslatedText(groupItem.title, groupItem.translate) }}</h5>
                  <hr class="border from-journal">
                  <!-- Index filtresi için özel arama kutusu -->
                  @if (shouldShowIndexSearch(groupItem)) {
                    <div class="mb-3">
                      <div class="search-container">
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          [placeholder]="'@SearchInIndexes' | translate"
                          [(ngModel)]="indexSearchTerm"
                          (input)="onIndexSearch($event)"
                          />
                          @if (indexSearchTerm) {
                            <button
                              type="button"
                              class="btn btn-sm btn-link clear-search"
                              (click)="clearIndexSearch()"
                              >
                              <i class="fas fa-times"></i>
                            </button>
                          }
                        </div>
                      </div>
                    }
                    <!-- Normal filtreleri göster (index değilse) veya özel index filtrelerini göster -->
                    @if (groupItem.key !== 'index' || type !== 'journal') {
                      @for (filter of groupItem.filters; track filter) {
                        <div class="form-check mb-1">
                          <label class="form-check-label" [class.text-muted]="isFilterProtected(filter, groupItem.key)">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="filter.EID"
                              [checked]="isFilterSelected(filter, groupItem.key)"
                              [disabled]="isFilterProtected(filter, groupItem.key)"
                              (change)="handleFilterChange(groupItem, filter)"
                              />
                              {{ getTranslatedText(filter.text, filter.translate) }}
                            </label>
                          </div>
                        }
                      }
                      <!-- Index filtreleri için özel gösterim -->
                      @if (groupItem.key === 'index' && type === 'journal') {
                        @for (filter of getDisplayedIndexFilters(groupItem); track filter) {
                          <div class="form-check mb-1">
                            <label class="form-check-label" [class.text-muted]="isFilterProtected(filter, groupItem.key)">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [id]="filter.EID"
                                [checked]="isFilterSelected(filter, groupItem.key)"
                                [disabled]="isFilterProtected(filter, groupItem.key)"
                                (change)="handleFilterChange(groupItem, filter)"
                                />
                                {{ getTranslatedText(filter.text, filter.translate) }}
                              </label>
                            </div>
                          }
                          <!-- "Daha fazla göster" butonu -->
                          @if (shouldShowIndexMore(groupItem)) {
                            <div class="mt-2 text-center">
                              <button
                                type="button"
                                class="btn btn-link btn-sm text-primary"
                                (click)="toggleIndexExpansion()"
                                >
                                <i class="fas fa-chevron-down me-1"></i>
                                {{ '@ShowMore' | translate }} ({{ getIndexRemainingCount(groupItem) }})
                              </button>
                            </div>
                          }
                          <!-- "Daha az göster" butonu -->
                          @if (isIndexExpanded && groupItem.key === 'index' && !indexSearchTerm) {
                            <div class="mt-2 text-center">
                              <button
                                type="button"
                                class="btn btn-link btn-sm text-primary"
                                (click)="toggleIndexExpansion()"
                                >
                                <i class="fas fa-chevron-up me-1"></i>
                                {{ '@ShowLess' | translate }}
                              </button>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <div class="col-md-9">
            <div class="form-row">
              <div class="form-group col">
                <mat-form-field appearance="outline" class="search-input">
                  <mat-label>{{ '@Search' | translate }}</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="term"
                    (keydown.enter)="onSearch($event)"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                  </mat-form-field>
                </div>
              </div>

              @if (appliedFilters.length > 0) {
                <div class="row mb-1" id="applied-filters2">
                  <div class="col">
                    @for (filter of appliedFilters; track filter) {
                      <div
                        class="filter-item"
                        [class.protected-filter]="isProtectedFilter(filter)">
                        <div class="left-col">
                          @if (!isProtectedFilter(filter)) {
                            <a (click)="removeFilter(filter)">
                              <i class="fas fa-times"></i>
                            </a>
                          }
                          @if (isProtectedFilter(filter)) {
                            <i class="fas fa-lock text-muted" title="Bu filtre kaldırılamaz"></i>
                          }
                        </div>
                        <div class="right-col">
                          <div>
                            <small class="text-muted">{{ getTranslatedText(filter.groupName || '', filter.translate) }}</small>
                          </div>
                          <div class="text-small">
                            {{ getTranslatedText(filter.text, filter.translate) }}
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }

              @if (isLoading) {
                <div class="text-center py-4">
                  <i class="fas fa-spinner fa-spin"></i>
                  {{ 'LOADING' | translate }}
                </div>
              }

              @if (!isLoading) {
                <div class="row">
                  @if (type === 'book') {
                    @for (item of dataList; track item) {
                      <div class="col-md-4 mb-3">
                        @if (isBook(item)) {
                          <div class="card border-radius-0 bg-color-light">
                            <a [routerLink]="['/book', item.slug, 'home']" target="_blank" class="card-link-container">
                              <div class="card-body">
                                <div class="year-badge"><span>3. Yıl</span></div>
                                <div class="text-center mb-2">
                                  <app-image-with-loader [imageUrl]="item.coverShowcaseImageUrl" [className]="'searchImg'"></app-image-with-loader>
                                </div>
                                <hr>
                                  <div class="title-container" [class.title-expanded]="isTitleExpanded(item.slug)">
                                    <h5 class="text-center mb-2"
                                      [title]="item.title"
                                      (mouseenter)="showTooltip(item.slug)"
                                      (mouseleave)="hideTooltip(item.slug)">
                                      {{ item.title }}
                                    </h5>
                                    @if (shouldTruncateTitle(item.title)) {
                                      <div class="expand-icon"
                                        (click)="toggleTitleExpansion(item.slug, $event)"
                                        [title]="isTitleExpanded(item.slug) ? 'Kısalt' : 'Tamamını Göster'">
                                        <i class="fas" [class.fa-chevron-down]="!isTitleExpanded(item.slug)"
                                        [class.fa-chevron-up]="isTitleExpanded(item.slug)"></i>
                                      </div>
                                    }
                                    @if (isTooltipVisible(item.slug) && shouldTruncateTitle(item.title) && !isTitleExpanded(item.slug)) {
                                      <div class="title-tooltip"
                                        >
                                        {{ item.title }}
                                      </div>
                                    }
                                  </div>
                                  <div class="row">
                                    <div class="col">
                                      <strong>e-ISBN:</strong> {{ item.eISBN || 'Belirtilmemiş' }}
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>
                          }
                        </div>
                      }
                    }
                    @if (type === 'journal') {
                      @for (item of dataList; track item) {
                        <div class="col-md-4 mb-3">
                          @if (isJournal(item)) {
                            <div class="card border-radius-0 bg-color-light">
                              <a [routerLink]="['/journal', item.slug, 'home']" target="_blank" class="card-link-container">
                                <div class="card-body">
                                  <div class="year-badge">
                                    <span>3. Yıl</span>
                                  </div>
                                  <div class="text-center mb-2">
                                    <app-image-with-loader [imageUrl]="item.coverShowcaseImageUrl" [className]="'searchImg'"></app-image-with-loader>
                                  </div>
                                  <hr>
                                    <div class="title-container" [class.title-expanded]="isTitleExpanded(item.slug)">
                                      <h5 class="text-center mb-2"
                                        [title]="item.name"
                                        (mouseenter)="showTooltip(item.slug)"
                                        (mouseleave)="hideTooltip(item.slug)">
                                        {{ item.name }}
                                      </h5>
                                      @if (shouldTruncateTitle(item.name)) {
                                        <div class="expand-icon"
                                          (click)="toggleTitleExpansion(item.slug, $event)"
                                          [title]="isTitleExpanded(item.slug) ? 'Kısalt' : 'Tamamını Göster'">
                                          <i class="fas" [class.fa-chevron-down]="!isTitleExpanded(item.slug)"
                                          [class.fa-chevron-up]="isTitleExpanded(item.slug)"></i>
                                        </div>
                                      }
                                      @if (isTooltipVisible(item.slug) && shouldTruncateTitle(item.name) && !isTitleExpanded(item.slug)) {
                                        <div class="title-tooltip"
                                          >
                                          {{ item.name }}
                                        </div>
                                      }
                                    </div>
                                    <div class="row">
                                      @if (hasValidISSN(item)) {
                                        @if (item.eISSN && item.eISSN !== '0000-0000') {
                                          <div class="col-6">
                                            <strong>e-ISSN</strong>
                                            <br>
                                              {{ item.eISSN }}
                                            </div>
                                          }
                                          @if (item.ISSN && item.ISSN !== '0000-0000') {
                                            <div class="col-6">
                                              <strong>ISSN</strong>
                                              <br>
                                                {{ item.ISSN }}
                                              </div>
                                            }
                                          } @else {
                                            <div class="col-12">
                                              <small class="text-muted">ISSN bilgisi mevcut değil</small>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                }
                              </div>
                            }
                          }
                          @if (type === 'article') {
                            <div class="col-md-12 mb-3">
                              <div class="card border-radius-0 bg-color-light">
                                <div class="card-body">
                                  <app-article-view [dataList]="dataList" [col]="1" [count]="200"></app-article-view>
                                </div>
                              </div>
                            </div>
                          }
                          @if (type === 'chapter') {
                            <div class="col-md-12 mb-3">
                              <div class="card border-radius-0 bg-color-light">
                                <div class="card-body">
                                  <app-chapter-view [dataList]="dataList" [col]="1" [count]="200" [includeAbstract]="true"></app-chapter-view>
                                </div>
                              </div>
                            </div>
                          }
                          @if (type === 'person') {
                            @for (item of dataList; track item) {
                              <div class="col-md-6 mb-3">
                                @if (isPerson(item)) {
                                  <div class="card border-radius-0 bg-color-light person-card">
                                    <div class="card-body">
                                      <app-author-content-view [author]="item"></app-author-content-view>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          }
                          @if (type === 'series') {
                            @for (item of dataList; track item) {
                              <div class="col-md-6 mb-3">
                                @if (isSeries(item)) {
                                  <div class="card border-radius-0 bg-color-light">
                                    <a [routerLink]="['/series', item.Slug, 'home']" target="_blank" class="card-link-container">
                                      <div class="card-body">
                                        <div class="text-center mb-2">
                                          <app-image-with-loader
                                            [imageUrl]="getSeriesImageUrl(item)"
                                            [className]="'searchImg'">
                                          </app-image-with-loader>
                                        </div>
                                        <hr>
                                          <div class="pt-2 font-weight-bold text-center mb-2 title-container" [class.title-expanded]="isTitleExpanded(item.slug)">
                                            <div [title]="item.title"
                                              (mouseenter)="showTooltip(item.Slug)"
                                              (mouseleave)="hideTooltip(item.Slug)">
                                              {{ item.Title }}
                                            </div>
                                            @if (shouldTruncateTitle(item.Title)) {
                                              <div class="expand-icon"
                                                (click)="toggleTitleExpansion(item.Slug, $event)"
                                                [title]="isTitleExpanded(item.Slug) ? 'Kısalt' : 'Tamamını Göster'">
                                                <i class="fas" [class.fa-chevron-down]="!isTitleExpanded(item.Slug)"
                                                [class.fa-chevron-up]="isTitleExpanded(item.Slug)"></i>
                                              </div>
                                            }
                                            @if (isTooltipVisible(item.Slug) && shouldTruncateTitle(item.Title) && !isTitleExpanded(item.Slug)) {
                                              <div class="title-tooltip"
                                                >
                                                {{ item.Title }}
                                              </div>
                                            }
                                          </div>
                                          @if (item.Description) {
                                            <div class="description-container">
                                              <div class="text-justify">
                                                {{ truncateDescription(item.Description, 300) }}
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                    </div>
                                  }
                                </div>
                              }
                            }
                            @if (dataList.length === 0 && !isLoading) {
                              <div class="col-12">
                                <div class="text-center py-5">
                                  <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                  <h4>{{ 'SEARCH_NO_RESULTS' | translate }}</h4>
                                  <p class="text-muted">{{ 'SEARCH_TRY_DIFFERENT_KEYWORDS' | translate }}</p>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>